/* eslint-disable import/prefer-default-export */
export const MANAGERTYPE = {
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  SDUSER: 'SDUSER',
};



// WEBPACK FOOTER //
// ./src/constants/account.js